import { NavigationPanelData } from '@frontend-mono/shared-ui-kit';

export enum NavigationPanelRoutes {
  ACTIVE = 'active',
  PENDING = 'pending',
  BLOCKED = 'blocked',
}

export const approvalRoutingData: NavigationPanelData[] = [
  {
    name: 'Pending Users',
    link: NavigationPanelRoutes.PENDING,
  }, {
    name: 'Active Users',
    link: NavigationPanelRoutes.ACTIVE,
  },
  // {
  //   name: 'Blocked Users',
  //   link: `${NavigationPanelRoutes.BLOCKED}`,
  // }
];


